import React from "react";
export default function TotalOrders() {
    const totalOrders = 0;
    return (
        <div className="total-orders-section">
            <div className="total-orders-card">
                <div className="glow-line"></div>
                <h2>Little Smiles Delivered So Far 🩷</h2>
                <div className="orders-count-wrapper">
                    <span className="orders-count">{totalOrders}</span>
                </div>
                <p className="sub-text">Trusted by thousands of happy customers</p>
            </div>
        </div>
    );
}